module.exports = require("./lo-LA");